import Link, { LinkProps } from "next/link";

interface ISmartLinkProps extends LinkProps {
  href: string | LinkProps["href"];
  children?: React.ReactNode;
}

const SmartLink = ({ href, children, ...props }: ISmartLinkProps) => {
  const isExternalLink =
    typeof href === "string" &&
    (href.search(/http|https/) !== -1 || href.includes("#webchat_widget"));

  if (isExternalLink) {
    return (
      <a href={href as string} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link passHref href={href} {...props} legacyBehavior>
      {children}
    </Link>
  );
};

export default SmartLink;
